import React, { useEffect, useState } from "react";
import "./home.css";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { FaPaperPlane, FaEarthAmericas, FaCar } from "react-icons/fa6";
import Aos from "aos";
import "aos/dist/aos.css";
import video from "../../assets/bg-1.mp4";
import Banner from "../Banner/Banner";

const Home = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="home">
      {/* SEO Tags */}
      <Helmet>
        {/* Title and meta */}
        <title>Myths Egypt Tours | Discover Egypt Today</title>
        <meta
          name="description"
          content="Plan your Egypt adventure with Myths Egypt Tours – personalized trips, Nile cruises, desert safaris, and unforgettable experiences from Cairo to Luxor and Aswan."
        />
        <meta
          name="keywords"
          content="Myths Egypt Tours, Egypt travel, Egypt tours, Nile cruise, Cairo tours, Luxor tours, Aswan packages, travel Egypt, tourism"
        />
        <meta name="author" content="Myths Egypt Tours" />

        {/* Open Graph (social preview) */}
        <meta property="og:title" content="Myths Egypt Tours | Explore Egypt with Experts" />
        <meta
          property="og:description"
          content="Book your next adventure with Myths Egypt Tours — discover Egypt’s wonders with tailored packages and professional guides."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mythsegypttours.com/" />
        <meta property="og:image" content="https://mythsegypttours.com/og-image.jpg" />

        {/* Schema.org JSON-LD for Google */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "TravelAgency",
              "name": "Myths Egypt Tours",
              "url": "https://mythsegypttours.com/",
              "logo": "https://mythsegypttours.com/logo192.png",
              "sameAs": [
                "https://www.facebook.com/mythsegypttours",
                "https://www.instagram.com/mythsegypttours"
              ],
              "description": "Myths Egypt Tours offers customized trips, Nile cruises, and Egypt travel experiences.",
              "address": {
                "@type": "PostalAddress",
                "addressCountry": "EG"
              }
            }
          `}
        </script>
      </Helmet>

      {/* الخلفية */}
      <Banner page="home" />
    </section>
  );
};

export default Home;
